import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { globalServices } from "../../Services/global.service";
import { posServices } from "../../Services/pos.service";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

const SuspensionPosModal = ({ show, handleHide, posId }) => {
  const history = useHistory();
  const [reasons, setReasons] = useState([]);
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, formState } = useForm();

  const confirmSuspension = (data) => {
    posServices
      .suspendPos(posId, data.suspensionNote)
      .then((res) => {
        handleHide();
      })
      .catch((err) => console.log(err));
  };

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header>
        <Modal.Title>{translator("PosDetail-SuspendPos")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container">
          <label>{translator("PosLogReason-SuspendReason")}:</label>
          <textarea
            id="textArea"
            ref={register({ required: true, maxLength: 200 })}
            className="form-control"
            rows={4}
            name="suspensionNote"
          />
          {errors.suspensionNote &&
            errors.suspensionNote.type === "required" && (
              <p className="text-danger">
                {translator("ValidationMsg-RequiredField")}
              </p>
            )}
          {errors.suspensionNote &&
            errors.suspensionNote.type === "maxLength" && (
              <p className="text-danger">
                {translator("ValidationMsg-MaxLength200")}
              </p>
            )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          {translator("General-Close")}
        </button>
        <button
          onClick={handleSubmit(confirmSuspension)}
          type="button"
          className="btn btn-primary"
        >
          {translator("Btn-suspend")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuspensionPosModal;
